import { render, staticRenderFns } from "./RTProgram.vue?vue&type=template&id=38e4ea51&scoped=true&"
import script from "./RTProgram.vue?vue&type=script&lang=js&"
export * from "./RTProgram.vue?vue&type=script&lang=js&"
import style0 from "./RTProgram.vue?vue&type=style&index=0&id=38e4ea51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e4ea51",
  null
  
)

export default component.exports